import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Checkout } from './pages/Checkout';
import { initMetaPixel, trackPageView } from './lib/metaPixel';
function MetaPixelTracker() {
  const location = useLocation();
  // Initialize the pixel once on first mount.
  useEffect(() => {
    initMetaPixel();
  }, []);
  // Fire a PageView on every client-side route change (after the first).
  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <MetaPixelTracker data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Landing data-id="element-4" />} data-id="element-3" />
        <Route path="/checkout" element={<Checkout data-id="element-6" />} data-id="element-5" />
      </Routes>
    </BrowserRouter>;
}